export const libTypeNameList = {
  hero: "英雄",
  map: "地图",
  announcer: "播报员",
  music: "音乐"
};

export const gameTypeList = [
  {active:false,tagType:"game",tagValue:"warcraft",name:"魔兽"},
  {active:false,tagType:"game",tagValue:"diablo",name:"暗黑"},
  {active:false,tagType:"game",tagValue:"starcraft",name:"星际"},
  {active:false,tagType:"game",tagValue:"overwatch",name:"守望"},
  {active:false,tagType:"game",tagValue:"retro",name:"经典"},
  {active:false,tagType:"game",tagValue:"nexus",name:"风暴"}
];

export const roleTypeList = [
  {active:false,tagType:"role",tagValue:"warrior",name:"战斗"},
  {active:false,tagType:"role",tagValue:"assassin",name:"刺杀"},
  {active:false,tagType:"role",tagValue:"support",name:"辅助"},
  {active:false,tagType:"role",tagValue:"specialist",name:"专业"}
];

export const heroVOCates = [
  {name: "吐槽",ID: 15},
  {name: "英雄互动，入场与击杀",ID: 13},
  {name: "发送游戏信号",ID: 14},
  {name: "移动与战斗",ID: 12},
  {name: "技能与天赋",ID: 17},
  {name: "终极进化（阿巴瑟大招）",ID: 10},
  {name: "电脑队友语音",ID: 11},
  {name: "社交",ID: 16},
  {name: "界面与功能",ID: 18},
  {name: "音效",ID: 19},
  {name: "未分类",ID:99}
];

export const heroVOLabels = [
  {name: "攻击",ID: 10},
  {name: "魔法耗尽",ID: 11},
  {name: "吐槽",ID: 12},
  {name: "嘲讽",ID: 13},
  {name: "选中",ID: 14},
  {name: "警告",ID: 15},
  {name: "庆祝",ID: 16},
  {name: "帮助",ID: 17},
  {name: "撤退",ID: 18},
  {name: "移动失败",ID: 19},
  {name: "死亡",ID: 20},
  {name: "提问",ID: 21},
  {name: "应答",ID: 22},
  {name: "地图元素",ID: 23},
  {name: "防守",ID: 24},
  {name: "复活",ID: 25},
  {name: "跳舞",ID: 26},
  {name: "再见",ID: 27},
  {name: "你好",ID: 28},
  {name: "抱歉",ID: 29},
  {name: "表示感谢",ID: 30},
  {name: "干得好",ID: 31},
  {name: "升级",ID: 32},
  {name: "礼物",ID: 33},
  {name: "开始游戏排队",ID: 34},
  {name: "英雄购买",ID: 35},
  {name: "英雄试用",ID: 36},
  {name: "大招",ID: 37},
  {name: "移动确认",ID: 38},
  {name: "击杀",ID: 39},
  {name: "其它",ID: 40},
  {name: "结束点赞",ID: 41},
  {name: "封面",ID: 42},
  {name: "技能",ID: 43},
  {name: "解锁语音",ID: 44},
  {name: "挨打",ID: 45},
  {name: "被拽",ID: 46},
  {name: "转晕",ID: 47},
  {name: "发呆",ID: 48},
  {name: "复仇",ID: 49},
  {name: "未分类",ID:99}
];

export const announcerVOCates = [
  {name: "地图变化",ID: 10},
  {name: "英雄击杀",ID: 11},
  {name: "游戏进度",ID: 12},
  {name: "音效",ID: 13},
  {name: "玩家事务",ID: 14},
  {name: "场外",ID: 15},
  {name: "未分类",ID:99}
];

export const announcerVOLabels = [
  {name: "建筑破坏",ID: 10},
  {name: "连杀终结",ID: 11},
  {name: "连杀",ID: 12},
  {name: "阵亡",ID: 13},
  {name: "一血",ID: 14},
  {name: "多杀",ID: 15},
  {name: "复活",ID: 16},
  {name: "倒计时",ID: 17},
  {name: "开局",ID: 18},
  {name: "结束",ID: 19},
  {name: "断线重连",ID: 20},
  {name: "天赋",ID: 22},
  {name: "放逐",ID: 23},
  {name: "雇佣兵",ID: 24},
  {name: "暂停",ID: 25},
  {name: "状态",ID: 26},
  {name: "音效",ID: 27},
  {name: "英雄禁选",ID: 28},
  {name: "开箱",ID: 29},
  {name: "未分类",ID:99}
]


// WEBPACK FOOTER //
// ./src/components/data.js